import React from 'react'

const LoadingComponent = () => {
  return (
      <div className="flex min-h-screen items-center justify-center bg-zinc-50 dark:bg-black">
          <div className="flex flex-col items-center space-y-6">
              {/* Gradient Spinner */}
              <div className="w-16 h-16 border-4 border-t-transparent border-b-transparent border-l-blue-500 border-r-purple-500 rounded-full animate-spin"></div>

              {/* Animated Dots Text */}
              <div className="flex space-x-2 text-zinc-700 dark:text-zinc-300 text-lg font-semibold">
                  <span>Loading ..</span>
                  <span className="flex space-x-1">
                      <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce delay-75"></span>
                      <span className="w-2 h-2 bg-purple-500 rounded-full animate-bounce delay-150"></span>
                      <span className="w-2 h-2 bg-pink-500 rounded-full animate-bounce delay-200"></span>
                  </span>
              </div>
          </div>
      </div>
  )
}

export default LoadingComponent